import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchAssetsProtectionPayrollData } from 'queries/assets-protection'
import { ShortageFetchProps } from 'types/api'
import { ITitleListResponse } from 'utils/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'

export function useAssetsProtectionStore({
    env,
    accessToken,
    location,
    filters,
}: ShortageFetchProps): ITitleListResponse {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.ASSETS_PROTECTION_STORE, location],
        () =>
            fetchAssetsProtectionPayrollData({
                env,
                accessToken,
                filters,
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
